import { getUserFacingCategoryName } from '@core/constants/product';
import Enums from '@core/types/api/Enums';

export const PRIMARY_PRODUCT_CATEGORIES = [
  Enums.ProductCategory.ReadyMix,
  Enums.ProductCategory.Aggregate,
  Enums.ProductCategory.Asphalt,
] as const;

export const categoryTabs = [
  {
    label: getUserFacingCategoryName(Enums.ProductCategory.ReadyMix),
    value: Enums.ProductCategory.ReadyMix,
  },
  {
    label: getUserFacingCategoryName(Enums.ProductCategory.Aggregate),
    value: Enums.ProductCategory.Aggregate,
  },
  {
    label: getUserFacingCategoryName(Enums.ProductCategory.Asphalt),
    value: Enums.ProductCategory.Asphalt,
  },
] as const;

export type PrimaryProductCategory = (typeof PRIMARY_PRODUCT_CATEGORIES)[number];

const primaryProductCategoriesSet = new Set<Enums.ProductCategory>(PRIMARY_PRODUCT_CATEGORIES);

export const getAvailableProductCategories = (
  userProductCategories: Enums.ProductCategory[],
): PrimaryProductCategory[] =>
  userProductCategories.filter((category): category is PrimaryProductCategory =>
    primaryProductCategoriesSet.has(category),
  );

export const getSingleProductCategory = (
  productCategories: Enums.ProductCategory[],
  disable?: boolean,
): PrimaryProductCategory | undefined => {
  const available = getAvailableProductCategories(productCategories);
  return !disable && available.length === 1 ? available[0] : undefined;
};
